import MainPic from "@ali/main-pic";
import MainPicWithAd from "@ali/main-pic-with-ad-tag";
import Title from "@ali/zr-title";
import Cpv from "@ali/zr-cpv";
import Dpa from "@ali/zr-dpa";
import PriceLine from "@ali/zr-price-line";
import CompanyInfo from "@ali/zr-company-info";
export default {
  MainPic: MainPic,
  MainPicWithAd: MainPicWithAd,
  Title: Title,
  Cpv: Cpv,
  Dpa: Dpa,
  PriceLine: PriceLine,
  CompanyInfo: CompanyInfo
};